/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListResponseDTO
 */
export interface ListResponseDTO {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ListResponseDTO
     */
    content?: { [key: string]: string; };
}

/**
 * Check if a given object implements the ListResponseDTO interface.
 */
export function instanceOfListResponseDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ListResponseDTOFromJSON(json: any): ListResponseDTO {
    return ListResponseDTOFromJSONTyped(json, false);
}

export function ListResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListResponseDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': !exists(json, 'content') ? undefined : json['content'],
    };
}

export function ListResponseDTOToJSON(value?: ListResponseDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content': value.content,
    };
}

